export const analyticsId = {
  CARD_CHANGE_NEW_PAYMENT_METHOD_STEP_1_VIEW: 'CARD_CHANGE_NEW_PAYMENT_METHOD_STEP_1_VIEW',
  CARD_CHANGE_NEW_PAYMENT_METHOD_STEP_2_VIEW: 'CARD_CHANGE_NEW_PAYMENT_METHOD_STEP_2_VIEW',
  CARD_CHANGE_NEW_PAYMENT_METHOD_STEP_3_VIEW: 'CARD_CHANGE_NEW_PAYMENT_METHOD_STEP_3_VIEW',
  CARD_CHANGE_NEW_PAYMENT_METHOD_WIZARD_FINISH: 'CARD_CHANGE_NEW_PAYMENT_METHOD_WIZARD_SUCCESS',
  CARD_CHANGE_NEW_PAYMENT_METHOD_NEXT: 'CARD_CHANGE_NEW_PAYMENT_METHOD_NEXT',
  CARD_CHANGE_NEW_PAYMENT_METHOD_CANCEL: 'CARD_CHANGE_NEW_PAYMENT_METHOD_CANCEL',
  CARD_CHANGE_NEW_PAYMENT_METHOD_PREVIOUS: 'CARD_CHANGE_NEW_PAYMENT_METHOD_PREVIOUS',
};

const commons = {
  sectionFamily: 'banking',
  sectionCategory: 'products',
  sectionName: 'cards',
  interactionType: 'funnel',
  serviceType: 'productTransactional',
  processType: 'changePaymentMethod',
};

export const catalogue = {
  [analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_STEP_1_VIEW]: ({ productName }) => ({
    ...commons,
    pageName: 'changePaymentMethod/step01/selectPaymentMethod',
    processStep: 'step01',
    processDetail: 'selectPaymentMethod',
  }),
  [analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_STEP_2_VIEW]: ({ productName }) => ({
    ...commons,
    pageName: 'changePaymentMethod/step02/precontractualInformation',
    processStep: 'step02',
    processDetail: 'precontractualInformation',
  }),
  [analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_STEP_3_VIEW]: ({ productName }) => ({
    ...commons,
    pageName: 'changePaymentMethod/step03/confirmation',
    processStep: 'step03',
    processDetail: 'confirmation',
  }),

  [analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_WIZARD_FINISH]: ({ pageName }) => ({
    action: 'click',
    format: 'button',
    component: 'lowerNavigation',
    element: 'changePaymentMethod',
    eventCategory: pageName,
    eventAction: 'lowerNavigation',
    eventLabel: 'navigationChangePaymentMethodButton',
    data: true
  }),
  [analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_NEXT]: ({ pageName }) => ({
    action: 'continue',
    format: 'button',
    component: 'lowerNavigation',
    element: 'next',
    eventCategory: pageName,
    eventAction: 'lowerNavigation',
    eventLabel: 'navigationNextButton',
    data: true
  }),
  [analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_CANCEL]: ({ pageName }) => ({
    action: 'cancel',
    format: 'link',
    component: 'lowerNavigation',
    element: 'cancel',
    eventCategory: pageName,
    eventAction: 'lowerNavigation',
    eventLabel: 'navigationCancelLink',
    data: true
  }),
  [analyticsId.CARD_CHANGE_NEW_PAYMENT_METHOD_PREVIOUS]: ({ pageName }) => ({
    action: 'back',
    format: 'button',
    component: 'lowerNavigation',
    element: 'previous',
    eventCategory: pageName,
    eventAction: 'lowerNavigation',
    eventLabel: 'previous',
    data: true
  }),
};
